import { render, staticRenderFns } from "./StaffTopFilter.vue?vue&type=template&id=08d1b68a&scoped=true&"
import script from "./StaffTopFilter.vue?vue&type=script&lang=js&"
export * from "./StaffTopFilter.vue?vue&type=script&lang=js&"
import style0 from "./StaffTopFilter.vue?vue&type=style&index=0&id=08d1b68a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d1b68a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
